import { subHours } from "date-fns/subHours";
import { useWorkspaces } from "@/hooks/useWorkspaces";
import { AnalysisService } from "@/services/analysis/analysis.service";

const RUNNING_STATUSES = [
  "QUEUED",
  "DATA_LOAD_RUNNING",
  "CATEGORY_CLASSIFICATION_RUNNING",
  "SHORT_SUMMARIZATION_RUNNING",
  "CATEGORY_SUMMARIZATION_RUNNING",
  "PROBLEM_CLASSIFICATION_RUNNING",
  "VIEW_DATA_REFRESH_RUNNING",
  "RAG_INDEXING_RUNNING",
];

export const useAnalyses = (limit: number = 10) => {
  const { sessionCurrentWorkspaceId } = useWorkspaces();
  const { analyses, error, isLoading, mutate } = AnalysisService.getAnalyses(sessionCurrentWorkspaceId);

  // とりあえず直近n件を表示、後で追加ロードを実装する
  const recentAnalyses = analyses?.slice(0, limit);

  // 直近4時間以内に実行された分析がある場合は分析実行中とみなす
  const isAnalysisRunning = analyses
    ?.filter((analysis) => analysis.startedAt > subHours(new Date(), 4))
    .some((analysis) => RUNNING_STATUSES.includes(analysis.status)) ?? true;

  const getAnalysis = (id: string) => analyses?.find((a) => a.id === id);
  const completedAnalyses = analyses?.filter((a) => a.status === "COMPLETED");

  return {
    analyses: recentAnalyses,
    completedAnalyses,
    latestAnalysis: completedAnalyses && completedAnalyses.length > 0
      ? completedAnalyses[0]
      : undefined,
    error,
    isLoading,
    isAnalysisRunning,
    mutate,
    getAnalysis,
  };
};
